import ClearableQueryFilter from 'components/ClearableQueryFilter'

import useTranslations from 'hooks/translations'
import useStudent from 'hooks/student'

export default function EventCategoryFilter (props) {

  const {translate} = useTranslations()
  const {eventCategories} = useStudent()

  return (<ClearableQueryFilter {...{...props,
    caption: translate('category'),
    name: 'eventCategory',
    items: eventCategories,
    getOptionValue: eventType => eventType,
    getOptionText: eventType => translate(`${eventType}-event-category`)
  }} />)
}